import { render, staticRenderFns } from "./SchemaCreateModal.vue?vue&type=template&id=c160b80c&"
import script from "./SchemaCreateModal.vue?vue&type=script&lang=js&"
export * from "./SchemaCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports